import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { Platform } from '@angular/cdk/platform';
import { environment } from '@environments/environment';

import { MensagemService } from '@app/shared/services/mensagem.service';
import { CookieService } from 'ngx-cookie-service';
import { DocumentosService } from '@app/shared/services';
import { CensoService } from '@app/shared/services/censo.service';

import { Censo } from '@app/shared/models';

@Component({
  selector: 'app-modal-documentos',
  templateUrl: './modal-documentos.component.html',
  styleUrls: ['./modal-documentos.component.scss'],
})
export class ModalDocumentosComponent implements OnInit {
  cliente = environment.cliente;
  carregandoFrente = false;
  carregandoVerso = false;

  formDocs: FormGroup;

  arquivo: any = {};

  frenteFile: any = null;
  versoFile: any = null;

  censo: Censo;

  @ViewChild('frenteDoc') frenteDoc: ElementRef<HTMLInputElement>;
  @ViewChild('versoDoc') versoDoc: ElementRef<HTMLInputElement>;

  constructor(
    public dialogRef: MatDialogRef<ModalDocumentosComponent>,
    public dialog: MatDialog,
    readonly platform: Platform,
    private docsService: DocumentosService,
    private cookieService: CookieService,
    private mensagemService: MensagemService,
    private censoService: CensoService
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');

    if ( this.cookieService.get('frenteFile') !== '' && this.cookieService.get('frenteFile') !== null ) {
      this.frenteFile = this.cookieService.get('frenteFile');
    }
    if ( this.cookieService.get('versoFile') !== '' && this.cookieService.get('versoFile') !== null ) {
      this.versoFile = this.cookieService.get('versoFile');
    }
  }

  ngOnInit(): void {
    this.formDocs = new FormGroup({
      frente: new FormControl(null, Validators.required),
      verso: new FormControl(null, Validators.required),
    });
  }

  onFrenteFileChange(event: any): void {
    const fileList: FileList = event.target.files;
      if (fileList.length > 0) {
        this.arquivo = fileList[0];
      }

      if (event.target.files && event.target.files.length <= 0) {
        return;
      }

      const file = event.target.files[0];
      const tipo = file.type.split('/')[1];

      const TAMANHO_MAXIMO_PDF = 2000000;
      const TAMANHO_MAXIMO_FOTOS = 1000000;

      if (this.arquivo != null && ['jpg', 'jpeg', 'png'].includes(tipo) && this.arquivo.size / TAMANHO_MAXIMO_FOTOS > 10) {
        this.arquivo = null;
        return this.mensagemService.avisoMensagemAlerta('O tamanho do arquivo não pode ser maior do que 10MB');
      }

      if (this.arquivo != null && ['pdf'].includes(tipo) && this.arquivo.size / TAMANHO_MAXIMO_PDF > 10) {
        this.arquivo = null;
        return this.mensagemService.avisoMensagemAlerta('O tamanho do arquivo não pode ser maior do que 20MB');
      }

      if (!['jpg', 'jpeg', 'png', 'pdf'].includes(tipo)) {
        this.arquivo = null;
        return this.mensagemService.avisoMensagemAlerta('Arquivo não suportado');
      }

      this.carregandoFrente = true;

      const formData = new FormData();
      formData.append('arquivo', this.arquivo);

      this.docsService
      .enviarDocumentoIdentificacao(formData, 'DOC_FRENTE').subscribe(() => {
        this.carregandoFrente = false;
        this.frenteFile = file;
        this.formDocs.patchValue({ frenteFile: file });
        this.cookieService.set('frenteFile', 'enviado');
      }, (error) => {
        this.arquivo = null;
        this.carregandoFrente = false;
        return this.mensagemService.avisoMensagemError();
      });
  }

  onVersoFileChange(event: any): void {
    const fileList: FileList = event.target.files;
      if (fileList.length > 0) {
        this.arquivo = fileList[0];
      }

      if (event.target.files && event.target.files.length <= 0) {
        return;
      }

      if (this.arquivo != null && this.arquivo.size / 5000000 > 10) {
        this.arquivo = null;
        return this.mensagemService.avisoMensagemAlerta('Arquivo ultrapassa os 50MB.');
      }

      const file = event.target.files[0];
      const tipo = file.type.split('/')[1];

      if (!['jpg', 'jpeg', 'png', 'pdf'].includes(tipo)) {
        this.arquivo = null;
        return this.mensagemService.avisoMensagemAlerta('Arquivo não suportado');
      }

      this.carregandoVerso = true;

      const formData = new FormData();
      formData.append('arquivo', this.arquivo);

      this.docsService
      .enviarDocumentoIdentificacao(formData, 'DOC_VERSO').subscribe(() => {
        this.carregandoVerso = false;
        this.versoFile = file;
        this.formDocs.patchValue({ versoFile: file });
        this.cookieService.set('versoFile', 'enviado');
      }, (error) => {
        this.arquivo = null;
        this.carregandoVerso = false;
        return this.mensagemService.avisoMensagemError();
      });
  }

  get isMobile(): boolean {
    return this.platform.ANDROID || this.platform.IOS;
  }

  voltar(): void {
    this.dialogRef.close();
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  salvar(): void {
    if (this.formDocs.valid) {
      this.dialogRef.close();
    }
  }

  setFrenteDoc(): void {
    this.frenteDoc.nativeElement.click();
  }

  setVersoDoc(): void {
    if (this.frenteFile == null) {
      return;
    }

    this.versoDoc.nativeElement.click();
  }
}
